import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SendEmailMessageComponent } from 'app/pages/email-messages/send-email-message/send-email-message.component';
import { SendSmsMessageComponent } from 'app/pages/sms-messages/send-sms-message/send-sms-message.component';
import { ModalBaseComponent } from 'app/shared/components/base/modal-base/modal-base.component';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { EmailMessage } from 'app/shared/models/email-message.model';
import { SmsMessage } from 'app/shared/models/sms-message.model';
import { SectionService } from 'app/shared/services/section.service';
import { ToastrService } from 'ngx-toastr';
import { PaymentAction } from 'app/shared/models/payment-action.model';
import { PaymentActionService } from 'app/shared/services/payment-action.service';

@Component({
  selector: 'app-payment-actions-url',
  templateUrl: './payment-actions-url.component.html',
  styleUrls: ['./payment-actions-url.component.scss']
})
export class PaymentActionsUrlComponent extends ModalBaseComponent implements OnInit {

  @Input() currentObject: PaymentAction;

  subject: string;
  body: string;
  smallBody: string;
  urlCopiedToClipboardMessage: string;
  paymentActionUrl: string;

  get hasSendUrlBySmsPermission(): boolean {
    return this.hasPermission(Permissions.PaymentActionsUrl_SendUrlBySms);
  }

  get hasSendUrlByEmailPermission(): boolean {
    return this.hasPermission(Permissions.PaymentActionsUrl_SendUrlByEmail);
  }

  get emailUrl(): string {
    return 'mailto:?subject=' + this.subject + '&body=' + encodeURIComponent(this.body);
  }

  get smsUrl(): string {
    return 'sms:?body=' + encodeURIComponent(this.smallBody);
  }

  get whatsAppUrl(): string {
    return 'whatsapp://send?text=' + encodeURIComponent(this.body);
  }

  get hidePayDirect(): boolean {
    return !(this.hasDesktopView);
  }

  constructor(
    protected sectionService: SectionService,
    protected modalService: NgbModal,
    private toastrService: ToastrService,
    protected activeModal: NgbActiveModal,
    protected translateService: TranslateService,
    protected paymentActionService: PaymentActionService) {
    super(activeModal, sectionService, Sections.PaymentActionsUrl);
  }

  ngOnInit(): void {
    super.initialize();
    this.paymentActionUrl = this.paymentActionService.getPaymentActionUrl(this.currentObject.CompanySlug, this.currentObject.Slug);
    this.translateService.get([
      'paymentActionUrl.sharePaymentRequestSubject',
      'paymentActionUrl.sharePaymentRequestBody',
      'paymentActionUrl.sharePaymentRequestSmallBody',
      'paymentActionUrl.urlCopiedToClipboardMessage'
    ], {
      CompanyName: this.currentObject.CompanyName,
      RemittanceInformation: this.currentObject.RemittanceInformation,
      AuthorizationUrl: this.paymentActionUrl,
    }).subscribe(translations => {
      this.subject = translations['paymentActionUrl.sharePaymentRequestSubject'];
      this.body = translations['paymentActionUrl.sharePaymentRequestBody'];
      this.smallBody = translations['paymentActionUrl.sharePaymentRequestSmallBody'];
      this.urlCopiedToClipboardMessage = translations['paymentActionUrl.urlCopiedToClipboardMessage'];
    });
  }

  copyUrl(value: string): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    if (document.execCommand('copy')) {
      this.toastrService.info(this.urlCopiedToClipboardMessage);
    }
    document.body.removeChild(selBox);
  }

  sendUrlBySms(): void {
    const modalReference = this.modalService.open(SendSmsMessageComponent, {windowClass: 'add-edit-modal'});
    const smsMessage: SmsMessage = new SmsMessage();
    smsMessage.Content = this.smallBody;
    modalReference.componentInstance.currentObject = Object.assign({}, smsMessage);
  }

  sendUrlByEmail(): void {
    const modalReference = this.modalService.open(SendEmailMessageComponent, {windowClass: 'add-edit-modal'});
    const emailMessage: EmailMessage = new EmailMessage();
    emailMessage.Subject = this.subject;
    emailMessage.Body = this.body;
    modalReference.componentInstance.currentObject = Object.assign({}, emailMessage);
  }

  onSubmit(form: NgForm): void {
    this.handleSubmit(form);
    window.open(this.paymentActionUrl, '_blank');
  }

  closeModal(): void {
    super.closeModal();
    this.afterSubmitEvent.emit();
  }
}
